import {
  Box,
  Modal,
  ModalBody,
  Button,
  Text,
  Input,
  Tabs,
} from "@flexisaf/flexibull2";
import TinyEditor from "../../custom/tinyEditor";
import Theme from "../../../theme";
import { useEffect, useRef, useState } from "react";
import { clientErrorHandler } from "../../../utils/errorHandlers";
import useSectionGet from "../../../hooks/sections/useSectionGet";
import SectionLoader from "../../custom/sectionLoader";
import useGetSectionImage from "../../../hooks/sections/useGetSectionImage";
import useSectionEditor from "../../../hooks/sections/useSectionEditor";
// import useAudioGet from "../../../hooks/audio/useAudioGet";
import styled from "styled-components";
import SectionImageUploader from "../SectionImageUploader";
import AudioUploader from "../AudioUploader";
import { resetSingleSection } from "../../../redux/section/reducer";
import { useDispatch } from "react-redux";

const SectionEditor = ({ open, closeModal, data, refetch, paperId }) => {
  const [titlePassage, setTitlePassage] = useState("");
  const editorRef = useRef(null);
  const [image, setImage] = useState();
  const [hasImage, setHasImage] = useState(false);
  const dispatch = useDispatch();
  const [selectedFile, setSelectedFile] = useState({
    file: null,
    listenOnce: true,
    id: null,
    upload: false,
  });
  const [activeTab] = useState(0);
  const { imageSrc } = useGetSectionImage({ id: data?.imageUrl });
  const {
    isEditing,
    createSection,
    isCreatingSection,
    editSection,
    editSectionMedia,
    createSectionMedia,
  } = useSectionEditor();
  const { section, isLoading } = useSectionGet({
    id: data?.id,
  });

  useEffect(() => {
    if (!section || !data?.id) return;
    setTitlePassage(section?.title || "");
    return () => {
      setTitlePassage("");
      dispatch(resetSingleSection());
    };
  }, [section, dispatch, setSelectedFile, data]);

  const onClose = () => {
    closeModal();
    setSelectedFile({ file: null, id: null, listenOnce: true });
    setHasImage(false);
    setTitlePassage("");
  };
  let media = image || selectedFile.file;
  const validateFields = (fieldData) => {
    if (editorRef.current.getContent() === "" || titlePassage === "") {
      clientErrorHandler("Please fill in a passage title and the content");
      return;
    } else {
      if (data?.id) {
        media ? editSectionMedia(fieldData) : editSection(fieldData);
      } else {
        media ? createSectionMedia(fieldData) : createSection(fieldData);
      }
    }
  };

  async function handleSubmit() {
    validateFields({
      data: {
        paperId,
        title: titlePassage,
        content: editorRef.current.getContent(),
        imageUrl: image ? image : data?.imageUrl,
        id: section?.id,
        multimediaFile: selectedFile,
      },
      callback: () => {
        onClose();
        refetch();
      },
    });
  }
  const updateImage = () => {
    setHasImage(true);
  };
  return (
    <Modal open={open}>
      <ModalBody
        width="60vw"
        style={{
          position: "relative",
          height: "auto",
          minHeight: "90vh",
          minWidth: "90vw",
          maxWidth: "1400px",
          padding: "40px",
        }}
      >
        {isLoading && data?.id ? (
          <SectionLoader height="60vh" />
        ) : (
          <Box height="100%">
            <Box pad="0 0 10px 0px">
              <Box>
                <Text bold block size="16px">
                  {data?.id ? "Edit" : "ADD NEW SECTION"}
                </Text>
              </Box>
              <Box pad="20px 0 0 0">
                <Input
                  placeholder="Paragraph"
                  label="Section title"
                  type="text"
                  spaceTop="20px"
                  spaceBottom="40px"
                  block
                  loading="true"
                  required
                  value={titlePassage}
                  onChange={(e) => setTitlePassage(e.target.value)}
                />
              </Box>
            </Box>
            <CustomeBox>
              <Tabs
                activeTab={activeTab}
                padContent="10px 0 0 0"
                bgColor={Theme.PrimaryFade}
              >
                <Box label="Passage">
                  <Box>
                    <Box style={{ width: "100%" }}>
                      <TinyEditor
                        editorRef={editorRef}
                        value={data?.id ? section?.content : ""}
                        height={400}
                        showMenuBar
                      />
                    </Box>
                  </Box>
                </Box>
                <Box label="Image">
                  <SectionImageUploader
                    hasImage={hasImage}
                    imageSrc={imageSrc}
                    setHasImage={setHasImage}
                    setImage={setImage}
                    image={image}
                    data={data}
                    updateImage={updateImage}
                  />
                </Box>

                <Box label="Audio">
                  <Box>
                    <AudioUploader
                      selectedFile={selectedFile}
                      setSelectedFile={setSelectedFile}
                    />
                  </Box>
                </Box>
              </Tabs>
            </CustomeBox>

            <Box pad="20px">
              <Box
                style={{
                  position: "absolute",
                  bottom: 25,
                  left: 30,
                  right: 30,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Box>
                  <Button pale color="transparent" onClick={onClose}>
                    Cancel
                  </Button>
                </Box>

                <Box>
                  <Button
                    progress={isEditing || isCreatingSection}
                    onClick={handleSubmit}
                  >
                    {data?.id ? "Edit" : "Add"} Section
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        )}
      </ModalBody>
    </Modal>
  );
};

export default SectionEditor;

const CustomeBox = styled(Box)`
  margin-top: -30px;
`;
